/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CompareRouteImport } from './routes/compare'
import { Route as DocsRouteRouteImport } from './routes/docs.route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DocsIndexRouteImport } from './routes/docs.index'
import { Route as DocsSharingRouteImport } from './routes/docs.sharing'
import { Route as DocsSelfHostRouteImport } from './routes/docs.self-host'
import { Route as DocsSecurityRouteImport } from './routes/docs.security'
import { Route as DocsQuickstartRouteImport } from './routes/docs.quickstart'
import { Route as DocsLocalStateRouteImport } from './routes/docs.local-state'
import { Route as DocsHostedRouteImport } from './routes/docs.hosted'
import { Route as DocsCliReferenceRouteImport } from './routes/docs.cli-reference'
import { Route as DocsAuthRouteImport } from './routes/docs.auth'
import { Route as DocsArchitectureRouteImport } from './routes/docs.architecture'

const CompareRoute = CompareRouteImport.update({
  id: '/compare',
  path: '/compare',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsRouteRoute = DocsRouteRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsIndexRoute = DocsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DocsRouteRoute,
} as any)
const DocsSharingRoute = DocsSharingRouteImport.update({
  id: '/sharing',
  path: '/sharing',
  getParentRoute: () => DocsRouteRoute,
} as any)
const DocsSelfHostRoute = DocsSelfHostRouteImport.update({
  id: '/self-host',
  path: '/self-host',
  getParentRoute: () => DocsRouteRoute,
} as any)
const DocsSecurityRoute = DocsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => DocsRouteRoute,
} as any)
const DocsQuickstartRoute = DocsQuickstartRouteImport.update({
  id: '/quickstart',
  path: '/quickstart',
  getParentRoute: () => DocsRouteRoute,
} as any)
const DocsLocalStateRoute = DocsLocalStateRouteImport.update({
  id: '/local-state',
  path: '/local-state',
  getParentRoute: () => DocsRouteRoute,
} as any)
const DocsHostedRoute = DocsHostedRouteImport.update({
  id: '/hosted',
  path: '/hosted',
  getParentRoute: () => DocsRouteRoute,
} as any)
const DocsCliReferenceRoute = DocsCliReferenceRouteImport.update({
  id: '/cli-reference',
  path: '/cli-reference',
  getParentRoute: () => DocsRouteRoute,
} as any)
const DocsAuthRoute = DocsAuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => DocsRouteRoute,
} as any)
const DocsArchitectureRoute = DocsArchitectureRouteImport.update({
  id: '/architecture',
  path: '/architecture',
  getParentRoute: () => DocsRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/docs': typeof DocsRouteRouteWithChildren
  '/compare': typeof CompareRoute
  '/docs/architecture': typeof DocsArchitectureRoute
  '/docs/auth': typeof DocsAuthRoute
  '/docs/cli-reference': typeof DocsCliReferenceRoute
  '/docs/hosted': typeof DocsHostedRoute
  '/docs/local-state': typeof DocsLocalStateRoute
  '/docs/quickstart': typeof DocsQuickstartRoute
  '/docs/security': typeof DocsSecurityRoute
  '/docs/self-host': typeof DocsSelfHostRoute
  '/docs/sharing': typeof DocsSharingRoute
  '/docs/': typeof DocsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/compare': typeof CompareRoute
  '/docs/architecture': typeof DocsArchitectureRoute
  '/docs/auth': typeof DocsAuthRoute
  '/docs/cli-reference': typeof DocsCliReferenceRoute
  '/docs/hosted': typeof DocsHostedRoute
  '/docs/local-state': typeof DocsLocalStateRoute
  '/docs/quickstart': typeof DocsQuickstartRoute
  '/docs/security': typeof DocsSecurityRoute
  '/docs/self-host': typeof DocsSelfHostRoute
  '/docs/sharing': typeof DocsSharingRoute
  '/docs': typeof DocsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/docs': typeof DocsRouteRouteWithChildren
  '/compare': typeof CompareRoute
  '/docs/architecture': typeof DocsArchitectureRoute
  '/docs/auth': typeof DocsAuthRoute
  '/docs/cli-reference': typeof DocsCliReferenceRoute
  '/docs/hosted': typeof DocsHostedRoute
  '/docs/local-state': typeof DocsLocalStateRoute
  '/docs/quickstart': typeof DocsQuickstartRoute
  '/docs/security': typeof DocsSecurityRoute
  '/docs/self-host': typeof DocsSelfHostRoute
  '/docs/sharing': typeof DocsSharingRoute
  '/docs/': typeof DocsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/docs'
    | '/compare'
    | '/docs/architecture'
    | '/docs/auth'
    | '/docs/cli-reference'
    | '/docs/hosted'
    | '/docs/local-state'
    | '/docs/quickstart'
    | '/docs/security'
    | '/docs/self-host'
    | '/docs/sharing'
    | '/docs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/compare'
    | '/docs/architecture'
    | '/docs/auth'
    | '/docs/cli-reference'
    | '/docs/hosted'
    | '/docs/local-state'
    | '/docs/quickstart'
    | '/docs/security'
    | '/docs/self-host'
    | '/docs/sharing'
    | '/docs'
  id:
    | '__root__'
    | '/'
    | '/docs'
    | '/compare'
    | '/docs/architecture'
    | '/docs/auth'
    | '/docs/cli-reference'
    | '/docs/hosted'
    | '/docs/local-state'
    | '/docs/quickstart'
    | '/docs/security'
    | '/docs/self-host'
    | '/docs/sharing'
    | '/docs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DocsRouteRoute: typeof DocsRouteRouteWithChildren
  CompareRoute: typeof CompareRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/compare': {
      id: '/compare'
      path: '/compare'
      fullPath: '/compare'
      preLoaderRoute: typeof CompareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs': {
      id: '/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof DocsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/': {
      id: '/docs/'
      path: '/'
      fullPath: '/docs/'
      preLoaderRoute: typeof DocsIndexRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/sharing': {
      id: '/docs/sharing'
      path: '/sharing'
      fullPath: '/docs/sharing'
      preLoaderRoute: typeof DocsSharingRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/self-host': {
      id: '/docs/self-host'
      path: '/self-host'
      fullPath: '/docs/self-host'
      preLoaderRoute: typeof DocsSelfHostRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/security': {
      id: '/docs/security'
      path: '/security'
      fullPath: '/docs/security'
      preLoaderRoute: typeof DocsSecurityRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/quickstart': {
      id: '/docs/quickstart'
      path: '/quickstart'
      fullPath: '/docs/quickstart'
      preLoaderRoute: typeof DocsQuickstartRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/local-state': {
      id: '/docs/local-state'
      path: '/local-state'
      fullPath: '/docs/local-state'
      preLoaderRoute: typeof DocsLocalStateRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/hosted': {
      id: '/docs/hosted'
      path: '/hosted'
      fullPath: '/docs/hosted'
      preLoaderRoute: typeof DocsHostedRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/cli-reference': {
      id: '/docs/cli-reference'
      path: '/cli-reference'
      fullPath: '/docs/cli-reference'
      preLoaderRoute: typeof DocsCliReferenceRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/auth': {
      id: '/docs/auth'
      path: '/auth'
      fullPath: '/docs/auth'
      preLoaderRoute: typeof DocsAuthRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/architecture': {
      id: '/docs/architecture'
      path: '/architecture'
      fullPath: '/docs/architecture'
      preLoaderRoute: typeof DocsArchitectureRouteImport
      parentRoute: typeof DocsRouteRoute
    }
  }
}

interface DocsRouteRouteChildren {
  DocsArchitectureRoute: typeof DocsArchitectureRoute
  DocsAuthRoute: typeof DocsAuthRoute
  DocsCliReferenceRoute: typeof DocsCliReferenceRoute
  DocsHostedRoute: typeof DocsHostedRoute
  DocsLocalStateRoute: typeof DocsLocalStateRoute
  DocsQuickstartRoute: typeof DocsQuickstartRoute
  DocsSecurityRoute: typeof DocsSecurityRoute
  DocsSelfHostRoute: typeof DocsSelfHostRoute
  DocsSharingRoute: typeof DocsSharingRoute
  DocsIndexRoute: typeof DocsIndexRoute
}

const DocsRouteRouteChildren: DocsRouteRouteChildren = {
  DocsArchitectureRoute: DocsArchitectureRoute,
  DocsAuthRoute: DocsAuthRoute,
  DocsCliReferenceRoute: DocsCliReferenceRoute,
  DocsHostedRoute: DocsHostedRoute,
  DocsLocalStateRoute: DocsLocalStateRoute,
  DocsQuickstartRoute: DocsQuickstartRoute,
  DocsSecurityRoute: DocsSecurityRoute,
  DocsSelfHostRoute: DocsSelfHostRoute,
  DocsSharingRoute: DocsSharingRoute,
  DocsIndexRoute: DocsIndexRoute,
}

const DocsRouteRouteWithChildren = DocsRouteRoute._addFileChildren(
  DocsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DocsRouteRoute: DocsRouteRouteWithChildren,
  CompareRoute: CompareRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
